import { render } from "./comp-Home.vue?vue&type=template&id=6a1e9539&scoped=true"
import script from "./comp-Home.vue?vue&type=script&lang=js"
export * from "./comp-Home.vue?vue&type=script&lang=js"

import "./comp-Home.vue?vue&type=style&index=0&id=6a1e9539&scoped=true&lang=css"

import exportComponent from "D:\\work\\kaifengzimaoqu\\wt_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a1e9539"]])

export default __exports__